import { Box, Button, Chip, TableCell, TableRow, Tooltip } from "@mui/material";
import { Visibility as VisibilityIcon, } from "@mui/icons-material";
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import { assetTypeList, assetTypeMap, typeFieldByAssetType } from "./AssetsConstants";
import { trackActivity } from "../../../utils/mixpanel";
import InfoIcon from '@mui/icons-material/Info'
import moment from "moment";
import { gaTelesisInstance, jetStreamInstance } from "../../../shared_elements";
import { dateMonthYearDateFormat } from "../../../constants";
import { getGlobalCookie, numberWithCommas } from "../../../utils";

const statusMap = {
    draft: {
        label: "Draft",
        color: "#89bfff",
        backgroundImage: "linear-gradient(90deg,#bedbfd,#dcebfc 95%)",
    },
    "on lease": {
        label: "on lease",
        color: "#5ec264",
        backgroundImage: "linear-gradient(90deg,#beed87,#d2e9b6 95%)",
    },
    closed: {
        label: "Closed",
        color: "#d32f2f",
        backgroundImage: "linear-gradient(269deg,#fcd5d5,#fca8a8 95%)",
    },
    terminated: {
        label: "Terminated",
        color: "#ff9800",
        backgroundImage: "linear-gradient(269deg,#fadfb8,#fdd79e 95%)",
    },
    "off lease": {
        label: "off lease",
        color: "#ee7c26",
        backgroundImage: "linear-gradient(269deg,#ffdfcb,#ffcdad 95%)",
    },
    "on ground": {
        label: "on ground",
        color: "#4c79d5",
        backgroundImage: "linear-gradient(90deg, #a7c4ff, #729cf1 95%)",
    },
    "written off / sold / part out": {
        label: "Written Off / Sold / Part out",
        color: "#333",
        backgroundImage: "linear-gradient(180deg, #d7d7d7, #f6f6f6 95%, #fff)",
    },
};

const LeaseLabel = ({ label, }) => {
    const statusKey = label?.toLowerCase?.();
    const status = statusMap[statusKey] || { label: label || "-", color: "#000" };
    return (
        <Button
            variant="contained"
            // onClick={statusChange}
            // endIcon={<ArrowDropDownIcon />}
            sx={{
                backgroundImage: status.backgroundImage,
                color: status.color,
                textTransform: "capitalize",
                padding: "0 6px",
                fontWeight: "600",
                alignItems: "center",
                fontSize: "13px",
                whiteSpace: "nowrap",
                width: "110px",
                lineHeight: "20px",
                whiteSpace: "normal",      
                wordBreak: "break-word",  
                justifyContent: "center",
                "& .MuiButton-endIcon": {
                    marginLeft: "0px",
                },
            }}
        >
            {status.label}
        </Button>

    );
};

const AssetsList = ({ item, onView, onClicktechnicalSpecification, onVariableRent,activeTab }) => {
    const showRegistration = activeTab === 0 || activeTab === 1 || (activeTab === 2 && gaTelesisInstance);

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Asset Listing`, page_type: page_type, })
    }

    const assetType = assetTypeMap[item?.asset_type];
    const typeField = typeFieldByAssetType[item?.asset_type] || `${assetType}_type`;
    const assetTypeName = item?.[typeField]?.name || "-";

    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="table-icon-container">
                    <Tooltip title="View"> <VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /> </Tooltip>
                    <Tooltip title="Technical Specification"> <AirplanemodeActiveIcon sx={{ cursor: 'pointer' }} onClick={() => { onClicktechnicalSpecification(); handleItemClicked('Technical Specification Icon') }} fontSize='small' color='primary' /> </Tooltip>
                </Box>
            </TableCell>
            <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                <Box className="asset-type-name-model">{`${assetTypeName}${item?.model ? ` / ${item.model}` : ""}`}</Box>
                <Box sx={{ fontWeight: 600 }}> {!item?.asset_name.startsWith(assetTypeList[item?.asset_type]) ? `${assetTypeList[item?.asset_type]} ${item?.asset_name}` : item?.asset_name || ""} </Box>
                {item?.ownership_type?.value === 2 ? <Box><Chip sx={{ fontSize: "10px", height: "18px", marginRight: "5px" }} label="Managed" size="small" variant="contained" color="primary" />
                {item?.owner_portfolio?.name ? <Tooltip placement='right' title={<span>{item?.owner_portfolio?.name}</span>} arrow>
                        <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '0px', fontSize: 'small' }} />
                    </Tooltip>:null }
                </Box> : null}
            </TableCell>
            <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}> {item?.lessor_name?.name || "--"}</TableCell>

            <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}> {item?.owner?.name || "--"}</TableCell>

            <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                {item?.lessee?.logo ? (
                    <>
                        <Tooltip title={item?.lessee?.name ? item?.lessee?.name : null} placement="top" arrow>
                            <Box className="lessee-logo-card">
                                <img src={item.lessee.logo} alt={item?.lessee?.name || "Lessee"} loading="lazy" className="lessee-logo-img" />
                            </Box>
                        </Tooltip>
                    </>
                ) : (item?.lessee?.name || "--")}
            </TableCell>
            
            {jetStreamInstance ? <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}> {item?.next_use || "--"}</TableCell> : null}
            {showRegistration ? <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}> {item?.current_registration_number || "--"}</TableCell> : null}
            <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.country || "--"}</TableCell>
            <TableCell sx={{ whiteSpace: "normal", cursor: 'pointer', wordBreak: 'break-word' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}><Tooltip title={`Airport Code: ${item?.airport_code || "--"}`} arrow> {item?.location || "--"}</Tooltip></TableCell>
            <TableCell onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                <div>
                    <LeaseLabel
                        label={item?.status?.label}
                    />
                    {item?.status?.value ?
                        <div style={{ background: '#e6e6e6', textAlign: 'center', marginTop: '5px',fontSize:'12px', maxWidth:'110px' }}>
                            {item?.status?.value === 1 ? item?.end_lease_date ? moment(item?.end_lease_date).format(dateMonthYearDateFormat).toUpperCase() : '--' : item?.status?.value === 2 && item?.previous_lessee && `EX: ${item?.previous_lessee || ""}`}
                        </div> : null
                    }
                </div>
            </TableCell>
            <TableCell sx={{ whiteSpace: "nowrap", cursor: 'pointer' }} onClick={() => { handleItemClicked('Clicked on Table data') }}>
                {item?.basic_rent_type ? item?.basic_rent_type?.value === 1 ? item?.basic_rent ? numberWithCommas(item?.basic_rent) : "--" : [2, 3, 4].includes(item?.basic_rent_type?.value) ? <>
                    <Button color="primary" variant="contained" sx={{ padding: "3px 6px", fontSize: '10px' }} onClick={() => { onVariableRent(); handleItemClicked('Clicked on Variable Rent') }}>Variable Rent </Button> 
                    <Tooltip placement='right' title={<span>Please click on info icon to view the Range conditions of Variable rent</span>} arrow>
                        <InfoIcon fontSize='small' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: 'small' }} />
                    </Tooltip>
                </>: "--" : "--"}
            </TableCell>
        </TableRow>
    );
};

export default AssetsList;
